<ng-container *ngIf="!(langService.languageLoading | async)">
    <router-outlet></router-outlet>
</ng-container>
<div @myanime *ngIf="langService.languageLoading | async" style="height: 100vh;width: 100vw;position: fixed;top: 0;left: 0;background-color: #FFF; display: flex;justify-content: center;align-items: center;">
    <span style="color: #444;font-size: 2rem;">...{{ 'loading' | translate }}...</span>
</div>

<!-- Audio List -->
<audio *ngIf="audioService.playAlertAudio$ | async" src="/assets/audios/strange_bell.mp3" autoplay loop></audio>